var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButtonSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.88884C18 15.2276 13.9706 19.5555 9 19.5555C4.02944 19.5555 0 15.2276 0 9.88884C0 4.55008 4.02944 0.222168 9 0.222168C13.9706 0.222168 18 4.55008 18 9.88884ZM4.31858 14.917C3.94224 14.5128 3.94224 13.8575 4.31858 13.4532L7.63716 9.88883L4.31858 6.32443C3.94224 5.92022 3.94224 5.26486 4.31858 4.86064C4.69492 4.45643 5.30508 4.45643 5.68142 4.86064L9 8.42505L12.3186 4.86064C12.6949 4.45643 13.3051 4.45643 13.6814 4.86064C14.0578 5.26486 14.0578 5.92022 13.6814 6.32443L10.3628 9.88883L13.6814 13.4532C14.0578 13.8575 14.0578 14.5128 13.6814 14.917C13.3051 15.3212 12.6949 15.3212 12.3186 14.917L9 11.3526L5.68142 14.917C5.30508 15.3212 4.69492 15.3212 4.31858 14.917Z",
    fill: "#556EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonSvg);
export default __webpack_public_path__ + "static/media/close-button-svg.bdb18e23.svg";
export { ForwardRef as ReactComponent };